import { CHAT_READ_CURSOR_NAMESPACE } from 'cpool-constants';
import { v5 as uuidv5 } from 'uuid';

/**
 * Deterministically derives the ChatReadCursor aggregate id for a (chat, user) pair.
 * Lives on its own namespace/stream so per-user read state never touches the replay-critical
 * Chat aggregate stream.
 */
export function deriveChatReadCursorId(chatId: string, userId: string): string {
    return uuidv5(`${chatId}:${userId}`, CHAT_READ_CURSOR_NAMESPACE);
}
